import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Cómo recibo el Megapack Fútbol Resuelto después de comprar?',
    a: 'Inmediatamente después de confirmar el pago recibís un email con el acceso a todos los PDF. En menos de 5 minutos tenés todo en tu dispositivo, listo para usar.'
  }, {
    q: '¿Sirve para instructores con poca experiencia o solo para los avanzados?',
    a: 'Está pensado para todos los niveles. Desde el instructor que está empezando y necesita estructura, hasta el que lleva años en la cancha y quiere profesionalizar su método. Los 6 tomos tienen progresión de nivel 1 a nivel 3 en cada ejercicio.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'Los PDF están optimizados para uso inmediato tal como están. Las planillas de los bonos sí son editables para que puedas completarlas con los datos de tu plantel.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos estratégicos están incluidos en las dos opciones sin costo adicional. La diferencia entre las opciones es que la versión completa incluye además el Fútbol Táctico Pro™.'
  }, {
    q: '¿Sirve si entreno a un solo grupo o solo para quien maneja varios equipos?',
    a: 'Funciona perfectamente para instructores con un solo grupo, con múltiples equipos, en clubes, en escuelas de fútbol o en trabajo particular. El sistema se adapta a tu situación.'
  }, {
    q: '¿Sirve si tengo jugadores de distintos niveles en el mismo grupo?',
    a: 'Exactamente para eso está diseñado. Cada ejercicio tiene variaciones en 3 niveles para que puedas trabajar con un grupo heterogéneo sin que nadie se quede atrás ni nadie se aburra.'
  }, {
    q: '¿Qué diferencia tiene con otros materiales de fútbol que encontré online?',
    a: 'La mayoría del material disponible son ejercicios sueltos sin progresión, sin planificación y sin sistema. El Megapack Fútbol Resuelto es un sistema completo de 720 páginas estructurado para que puedas usarlo directamente en la cancha, sin adaptar nada.'
  }, {
    q: '¿Por qué elegir el Megapack + Fútbol Táctico Pro y no el estándar?',
    a: 'Si ya dirigís un equipo que compite o querés empezar a trabajar en contextos más exigentes, el Fútbol Táctico Pro te da las herramientas para analizar rivales, gestionar partidos y construir tu propio modelo de juego. Es la diferencia entre un instructor y un director técnico.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas. Sin formularios complicados. Sin drama.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-white" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <h2 className="text-2xl md:text-5xl font-black text-center text-dark mb-6 md:mb-12" data-id="element-86">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2 md:space-y-4" data-id="element-87">
          {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-lg md:rounded-xl overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-3 md:p-6 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-89">
                <span className="font-bold text-dark pr-3 text-sm md:text-base" data-id="element-90">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-91">
                  <ChevronDown className="w-4 h-4 md:w-5 md:h-5 text-primary flex-shrink-0" data-id="element-92" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-93">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-94">
                    <div className="p-3 md:p-6 bg-white border-t border-gray-100" data-id="element-95">
                      <p className="text-gray-600 font-medium leading-relaxed text-sm md:text-base" data-id="element-96">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}